/**
 * Shared currency formatter (EUR). Use for consistent amount display across modules.
 */
export function formatCurrency(amount?: number | null): string {
  if (amount == null) return '-';
  return new Intl.NumberFormat('en-IE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
